import {UrlMatchResult, UrlSegment} from '@angular/router';

export class StringUtil {

  public static optional(str: string | null | undefined): string | null {
    if (!str) {
      return null;
    }
    return str;
  }

  public static trim(str: string | null | undefined): string | null {
    if (!str) {
      return null;
    }
    str = str.trim();
    if (str === '') {
      return null;
    }
    return str;
  }

  private static readonly MAX_SLUG_LENGTH = 500;
  public static readonly SLUG_SEPARATOR = '_';
  public static readonly SLUG_SPACER = '-';
  public static slugify(str: string | null | undefined): string | null {
    if (!str) {
      return null;
    }
    const slug = str.normalize('NFKD')        // normalize accented and compatibility characters
      .replace(/[\u0300-\u036f]/g, '')  // remove combining marks
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')     // remove non-alphanumeric chars
      .replace(/\s+/g, this.SLUG_SPACER)             // replace spaces with hyphens
      .replace(/-+/g, '-');             // collapse multiple hyphens
    if (slug.length < this.MAX_SLUG_LENGTH) {
      return slug;
    }
    return slug.substring(0, this.MAX_SLUG_LENGTH);
  }

  public static resolveSlug(slug: string | null | undefined): string | null {
    if (!slug) {
      return null;
    }
    return slug.split(StringUtil.SLUG_SEPARATOR).pop() ?? null;
  }

  public static mergeParams(str: string | null | undefined, params: {[name: string]: string;} = {}): string | null {
    if (str === null || str === undefined) {
      return null;
    }
    let result = str;
    for (const [param, value] of Object.entries(params)) {
      result = result.replace(':' + param, value);
    }
    return result;
  }

}
